import PropTypes from "prop-types";
import styled from "styled-components";

import { Table } from "components/Table/index";
import { columns } from "./columns";
import { Title } from "style/components/Title.styles";

const ScrollableTableContainer = styled.div`
  .table-container {
    .table-scroll-wrapper {
      max-height: 350px;
      overflow-y: auto;

      .table-wrapper {
        tbody {
          tr {
            height: 60px;
            td {
              width: 120px; // manually passing since column props aren't working
            }
          }
        }
      }
    }
  }
`;

export const BacktestLogs = ({ data = [], isLoading }) => {
  return (
    <>
      <Title className="mb-0">Backtest Logs</Title>
      <div className="divider mt-3 mb-0"></div>
      <ScrollableTableContainer className="trades-table">
        <Table
          isLoading={isLoading}
          data={data}
          columns={columns}
          showPagination={false}
          initialPageSize={data.length || 100}
          totalRecords={data.length}
        />
      </ScrollableTableContainer>
    </>
  );
};

BacktestLogs.propTypes = {
  isLoading: PropTypes.bool,
  data: PropTypes.array,
};
